var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66732 13.3333V12H3.33398V3.99996H4.66732V2.66663H6.00065V3.99996H7.33398V12H6.00065V13.3333H4.66732ZM4.66732 10.6666H6.00065V5.33329H4.66732V10.6666ZM10.0007 13.3333V9.99996H8.66732V5.33329H10.0007V2.66663H11.334V5.33329H12.6673V9.99996H11.334V13.3333H10.0007ZM10.0007 8.66663H11.334V6.66663H10.0007V8.66663Z",
    fill: "white"
  })));
}

export default __webpack_public_path__ + "media/6fcd4fbf.svg";
export { SvgExchange as ReactComponent };